import { empty } from '../../php-compat';
import { get, values, type ReadEnv, type Storage } from './shared';

/** PHP: count_player_characters_in_encounter_for_legendary_pool (includes/functions/janus/encounter/count_player_characters_in_encounter_for_legendary_pool.php:11) */
export function countPlayerCharactersInEncounterForLegendaryPool(encounter: Storage, env: ReadEnv): number {
    let n = 0;
    for (const participant of values(get(encounter, 'encounter_creatures_arr') ?? [])) {
        const ec = get(participant, 'encounter_creatures') ?? [];
        if (empty(env.deps.item_field(ec, 'item_type'))
            || (env.deps.item_field(ec, 'item_type') ?? '') !== 'player_character'
            || !empty(env.deps.encounter_creature_field(ec, 'encounter_creature_dead'))
            || !empty(env.deps.encounter_creature_field(ec, 'encounter_creature_private'))
            || !empty(env.deps.encounter_creature_field(ec, 'controller_encounter_creature_id'))) continue;
        n++;
    }
    return n;
}
